/* eslint-disable react/no-danger */
import React from 'react';
import DayJS from 'react-dayjs';
import PropTypes from 'prop-types';
import CommunityLogoWithLink from '../Community/CommunityLogoWithLink';
import CommunityContact from '../Community/CommunityContact';

import './BrochurePageHeader.scss';

const BrochurePageHeader = ({ headerData }) => {
  const {
    community, names, createdDate, changedDate, message,
  } = headerData || {};
  const { greeting } = community || {};

  return (
    <div className="pibPageHeader">
      <div className="pibPage-branding">
        <CommunityLogoWithLink className="pibPage-branding__logoLink" communityData={community} />
      </div>

      <div className="pibPage-welcome">
        <div className="pibPage-welcome__intro">
          {names && (
            <>
              {`${names}, ` || ''}
              {greeting || 'Your Personalized Interactive Brochure Is Ready.'}
            </>
          )}
        </div>

        <CommunityContact className="pibPage-welcome__contact" residentCommunityData={headerData} />

        <div className="pibPage-welcome__date">
          {createdDate && (
            <>
              Personalized
              {' '}
              <DayJS element="span" format="MMMM D[,] YYYY">
                {createdDate}
              </DayJS>
              {changedDate && (
                <>
                  {' '}
                  — Last edited
                  {' '}
                  <DayJS element="span" format="MMMM D[,] YYYY">
                    {changedDate}
                  </DayJS>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {message && (
        <div className="pibPage-message">
          <div className="pibPage-message__body">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>
      )}
    </div>
  );
};

BrochurePageHeader.propTypes = {
  headerData: PropTypes.shape({
    community: PropTypes.shape({
      name: PropTypes.string,
      greeting: PropTypes.string,
    }),
    salesCounselor: PropTypes.shape({}),
    names: PropTypes.string,
    createdDate: PropTypes.string,
    changedDate: PropTypes.string,
    message: PropTypes.string,
  }),
};

BrochurePageHeader.defaultProps = {
  headerData: null,
};

export default BrochurePageHeader;
